import React from 'react';
import cs from 'classnames';

export const ButtonGroup = ({ options = [], selectedId, onChange, classNames }) => {
  return (
    <div className={classNames}>
      {options.map((op, idx) => (
        <button
          key={idx}
          onClick={() => onChange(op.value)}
          className={cs(
            'h-6 border rounded-sm text-xs px-[16px]',
            { 'bg-primary/10 border-primary': selectedId === op.value },
            { 'border-transparent bg-[#f4f6f8] text-[#2d2d2d]': selectedId !== op.value },
          )}
        >
          {op.label}
        </button>
      ))}
    </div>
  );
};
